import "./Home.module.css";
import WebsiteHeader from "@/reusable_sections/Header";
import GlobalLogisticsSimplified from "./sections/GlobalLogisticsSimplified";
import OurLocalLegacy from "./sections/OurLocalLegacy";
import RideCategories from "./sections/RideCategories";
import ChooseTheRightPackage from "./sections/ChooseTheRightPackage";
import NeighborsExperiences from "./sections/NeighborsExperiences";
import FaleComEspecialistas from "./sections/FaleComEspecialistas";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <WebsiteHeader />
      <GlobalLogisticsSimplified />
      <OurLocalLegacy />
      <RideCategories />
      <ChooseTheRightPackage />
      <NeighborsExperiences />
      <FaleComEspecialistas />
      <Footer />
    </div>;
}